import { LimitTransactionsMobile } from '@constants/transactions';

export const isLimitMobile = (perPage) => perPage >= LimitTransactionsMobile;
